var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('panel',{staticClass:"placeholder"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"icon"}),_vm._v(" "),_c('div',{staticClass:"title"})]),_vm._v(" "),_c('div',{staticClass:"metrics"},_vm._l((3),function(index){return _c('div',{key:index,staticClass:"metric"},[_c('metric-placeholder')],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-210e9a4e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/ProjectOverviewPlaceholder.vue
// module id = null
// module chunks = 